import React, { useState } from "react";

const FORM_ENDPOINT = "https://formspree.io/f/xwpqneop";

export default function BetaWaitlistForm() {
  const [status, setStatus] = useState("idle"); 
  // idle | submitting | success | error
  const [errors, setErrors] = useState({});

  const validateField = (name, value) => {
    if (!value || !String(value).trim()) return "Please fill out this field.";
    if (name === "email") {
      const ok = /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value);
      if (!ok) return "Please enter a valid email address.";
    }
    return "";
  };

  const validateAll = (form) => {
    const data = new FormData(form);
    const newErrors = {};
    for (const [name, value] of data.entries()) {
      if (["_subject", "_gotcha"].includes(name)) continue; 
      // ignore hidden fields
      const msg = validateField(name, value);
      if (msg) newErrors[name] = msg;
    }
    setErrors(newErrors);
    return newErrors;
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const msg = validateField(name, value);
    setErrors((prev) => ({ ...prev, [name]: msg }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const newErrors = validateAll(form);
    if (Object.keys(newErrors).length > 0) return; 
    // block submit if any errors

    setStatus("submitting");
    const data = new FormData(form);

    try {
      const res = await fetch(FORM_ENDPOINT, {
        method: "POST",
        body: data,
        headers: { Accept: "application/json" },
      });
      if (res.ok) {
        setStatus("success");
        form.reset();
        setErrors({});
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }
  };

  return (
    <div className="demo-wrap">
      <div className="section card">
        <h3 className="section-title center">now accepting beta testers!</h3>

        {status === "success" ? (
          <p className="success-msg" role="status" aria-live="polite">
            Thanks for your submission! We’ll reach out soon.
          </p>
        ) : (
          <form className="left-form" onSubmit={handleSubmit} noValidate>
            {/* Formspree helpers */}
            <input type="hidden" name="_subject" value="New Beta Tester Signup" />
            <input type="text" name="_gotcha" className="hp" tabIndex={-1} autoComplete="off" />

            <label className="fld-label" htmlFor="firstName">First name:</label>
            <div className="fld-col">
              <input
                id="firstName"
                name="firstName"
                className={`fld-input ${errors.firstName ? "invalid" : ""}`}
                type="text"
                autoComplete="given-name"
                onBlur={handleBlur}
                aria-invalid={Boolean(errors.firstName)}
                aria-describedby={errors.firstName ? "firstName-error" : undefined}
              />
              {errors.firstName && (
                <p id="firstName-error" className="error-text">{errors.firstName}</p>
              )}
            </div>

            <label className="fld-label" htmlFor="lastName">Last name:</label>
            <div className="fld-col">
              <input
                id="lastName"
                name="lastName"
                className={`fld-input ${errors.lastName ? "invalid" : ""}`}
                type="text"
                autoComplete="family-name"
                onBlur={handleBlur}
                aria-invalid={Boolean(errors.lastName)}
                aria-describedby={errors.lastName ? "lastName-error" : undefined}
              />
              {errors.lastName && (
                <p id="lastName-error" className="error-text">{errors.lastName}</p>
              )}
            </div>

            <label className="fld-label" htmlFor="email">Email (Business or Personal, whichever you use most):</label>
            <div className="fld-col">
              <input
                id="email"
                name="email"
                className={`fld-input ${errors.email ? "invalid" : ""}`}
                type="email"
                autoComplete="email"
                inputMode="email"
                onBlur={handleBlur}
                aria-invalid={Boolean(errors.email)}
                aria-describedby={errors.email ? "email-error" : undefined}
              />
              {errors.email && (
                <p id="email-error" className="error-text">{errors.email}</p>
              )}
            </div>

            <label className="fld-label" htmlFor="business">Business description (tell me what your business does):</label>
            <div className="fld-col">
              <textarea
                id="business"
                name="businessDescription"
                className={`fld-textarea ${errors.businessDescription ? "invalid" : ""}`}
                rows={3}
                onBlur={handleBlur}
                aria-invalid={Boolean(errors.businessDescription)}
                aria-describedby={errors.businessDescription ? "business-error" : undefined}
              />
              {errors.businessDescription && (
                <p id="business-error" className="error-text">{errors.businessDescription}</p>
              )}
            </div>

            <label className="fld-label" htmlFor="benefit">Tell me how you hope you'll benefit from participating in beta testing:</label>
            <div className="fld-col">
              <textarea
                id="benefit"
                name="benefit"
                className={`fld-textarea ${errors.benefit ? "invalid" : ""}`}
                rows={3}
                onBlur={handleBlur}
                aria-invalid={Boolean(errors.benefit)}
                aria-describedby={errors.benefit ? "benefit-error" : undefined}
              />
              {errors.benefit && (
                <p id="benefit-error" className="error-text">{errors.benefit}</p>
              )}
            </div>

            <span className="fld-label" aria-hidden />
            <button className="btn" type="submit" disabled={status === "submitting"}>
              {status === "submitting" ? "Submitting..." : "join"}
            </button>
          </form>
        )}

        {status === "error" && (
          <p className="error-msg" role="alert">Oops! Something went wrong. Please try again.</p>
        )}
      </div>
    </div>
  );
}
